import { IPostCardProps } from '@/interfaces/card';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const ItemRightTableList = ({
  category,
  slug,
  id,
  title,
  thumbnail,
}: IPostCardProps) => {
  return (
    <Link
      href={`/${category?.slug}/${slug}-${id}`}
      className="grid grid-cols-3 gap-4"
    >
      <div className="col-span-1 h-[110px] lg:h-[70px] md:h-[160px] xl:h-[110px] relative rounded-xl overflow-hidden">
        <Image
          src={thumbnail ?? ''}
          alt={'thumbnail'}
          // className="object-cover"
          style={{ objectFit: 'cover' }}
          fill
          quality={70}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        />
      </div>
      <div className="col-span-2 text-[16px] font-bold line-clamp-3 h-fit">
        {title}
      </div>
    </Link>
  );
};

export default ItemRightTableList;
